/** Same-origin kernel calls through the session gateway (it injects the kernel token). */
import { KERNEL_API_URL } from "./config";

export async function kernel<T>(path: string): Promise<T> {
  const res = await fetch(`${KERNEL_API_URL}${path}`, { credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error((data as { error?: string }).error ?? `HTTP ${res.status}`), { status: res.status });
  return data as T;
}
